import { render } from "./MatchTracker.vue?vue&type=template&id=1f2b0827"
import script from "./MatchTracker.vue?vue&type=script&lang=js"
export * from "./MatchTracker.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__